module.exports = __webpack_public_path__ + "img/akron.12f99174.jpeg";